//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/**
* События жизненного цикла приложения МойСклад (vendor API). Используются для аналитики по датам;
*               прямых данных об оплате нет — по полям <see cref="P:mpsklad_core.Entity.MoySkladAppLifecycleEvent.Trial" /> и виду события можно оценивать платные продления/покупки.
*/
export enum MoySkladAppLifecycleEventKind {
  Install = 0,
  Resume = 1,
  TariffChanged = 2,
  Autoprolongation = 3,
  Suspend = 4,
  UninstallRequested = 5,
  UninstallCompleted = 6
}
